import { AxiosResponse } from 'axios';

export class ApiResponseError extends Error {
  response?: AxiosResponse;

  constructor(response?: AxiosResponse) {
    super(response ? `Request failed with status code ${response.status}` : 'Network Error');
    this.name = 'ApiResponseError';
    this.response = response;
  }
}

export const ensureOk = <T>(response: AxiosResponse<T> | undefined): AxiosResponse<T> => {
  if (!response || response.status >= 400) throw new ApiResponseError(response);

  return response;
};

export const apiErrorMessage = (err: unknown, fallback: string): string => {
  const message = (err as ApiResponseError | undefined)?.response?.data?.error;

  return typeof message === 'string' && message ? message : fallback;
};
